import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import {
  BaseMessageType,
  Image,
  ImageMessage,
} from '@/views/Automation/CampaignCreatorV2/components/Modals/CcAddImageModal/types';
import icons from '@/views/Automation/CampaignCreatorV2/helpers/icons';
import { isDefined } from '@sh/helpers';

// Duplicated types because vue < 3.3 doesn't support declaring Props with an imported type

interface Props extends Omit<Image, 'category'> {
  id: string;
  image_url: string;
  name?: string;
  width?: number;
  height?: number;
  size?: number;
  disabled?: boolean;
  selected: boolean;
  message?: ImageMessage;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcImageCard.ts',
  props: {
    id: null,
    image_url: null,
    name: null,
    width: { default: 818 },
    height: { default: 260 },
    size: { default: 18.046 },
    disabled: { type: Boolean },
    selected: { type: Boolean, default: false },
    message: null
  },
  emits: ['onSelectToggle', 'onImageError'],
  setup(__props: any, { emit: emits }) {

const props = __props as { id: string, image_url: string, name?: string, width: number, height: number, size: number, disabled?: boolean, selected: boolean, message?: ImageMessage };





function onSelectToggle() {
  if (props.message?.type !== BaseMessageType.ERROR) {
    emits('onSelectToggle');
  }
}

function handleImageError(event: Event) {
  const eventTarget = event.target as HTMLImageElement;

  if (eventTarget && !eventTarget?.dataset.image_error) {
    eventTarget.outerHTML = icons.image;
  }
  emits('onImageError');
}

return { __sfc: true,props, emits, onSelectToggle, handleImageError, CcIcon, BaseMessageType, isDefined }
}

})